import CRUD from './crud'

export default new CRUD('tournaments')
